module.exports = __webpack_public_path__ + "img/money-outlined-blue.1037bcf3.svg";